import api from "../proxy/config";
import axios from "./axiosConfig";
import {
  parseNewsletterHistoryDetail,
  parseNewsletterHistoryListResponse,
  parseNewsletterPublishResponse,
} from "./schemas/newsletterHistorySchemas";

const authHeaders = () => ({
  headers: {
    Authorization: `Bearer ${JSON.parse(sessionStorage.getItem("token"))}`,
  },
  skipGlobalErrorHandler: true,
});

const extractErrorMessage = (error, fallback) => {
  const backendError = error.response?.data;
  if (typeof backendError === "string") {
    return backendError;
  }
  if (backendError?.message) {
    return backendError.message;
  }
  if (backendError?.error) {
    return backendError.error;
  }
  return fallback;
};

export const getNewsletterSubscribersByFilter = async (
  searchQuery,
  page,
  size,
  sortDirection = "asc",
  ordinamentoCampo = "EMAIL",
  subscriberTypes = []
) => {
  try {
    const response = await axios.post(
      api.ricercaNewsletter,
      {
        searchFieldValue: searchQuery || "",
        subscriberTypes: subscriberTypes?.length ? subscriberTypes : undefined,
        limit: size,
        offset: page * size,
        ordinamento: sortDirection.toUpperCase(),
        ordinamentoCampo,
      },
      authHeaders()
    );
    return response.data;
  } catch (error) {
    throw new Error(extractErrorMessage(error, "Errore nel recupero degli iscritti alla newsletter"));
  }
};

export const listNewsletterRecipients = async ({ searchFieldValue = "", subscriberTypes = [] } = {}) => {
  try {
    const response = await axios.post(
      api.newsletterDestinatari,
      {
        searchFieldValue: searchFieldValue || "",
        subscriberTypes: subscriberTypes?.length ? subscriberTypes : undefined,
      },
      authHeaders()
    );
    return response.data;
  } catch (error) {
    throw new Error(extractErrorMessage(error, "Errore nel recupero dei destinatari newsletter"));
  }
};

export const publishNewsletter = async ({ emails, subject, htmlBody, scheduledAt }) => {
  try {
    const payload = {
      emails,
      subject,
      htmlBody,
    };
    if (scheduledAt) {
      payload.scheduledAt = scheduledAt;
    }
    const response = await axios.post(api.newsletterPubblica, payload, authHeaders());
    return parseNewsletterPublishResponse(response.data);
  } catch (error) {
    throw new Error(extractErrorMessage(error, "Errore durante l'invio della newsletter"));
  }
};

export const searchNewsletterHistory = async ({
  searchFieldValue = "",
  status,
  dateFrom,
  dateTo,
  limit,
  offset,
  ordinamento = "DESC",
  ordinamentoCampo = "CREATED_AT",
}) => {
  try {
    const response = await axios.post(
      api.newsletterStoricoRicerca,
      {
        searchFieldValue: searchFieldValue || undefined,
        status: status?.length ? status : undefined,
        dateFrom: dateFrom || undefined,
        dateTo: dateTo || undefined,
        limit,
        offset,
        ordinamento,
        ordinamentoCampo,
      },
      authHeaders()
    );
    return parseNewsletterHistoryListResponse(response.data);
  } catch (error) {
    throw new Error(extractErrorMessage(error, "Errore nel recupero dello storico newsletter"));
  }
};

export const getNewsletterHistoryDetail = async (id) => {
  try {
    const response = await axios.post(api.newsletterStoricoDettaglio, { id }, authHeaders());
    return parseNewsletterHistoryDetail(response.data);
  } catch (error) {
    throw new Error(extractErrorMessage(error, "Errore nel recupero del dettaglio newsletter"));
  }
};

export const cancelScheduledNewsletterHistory = async (id) => {
  try {
    const response = await axios.post(api.newsletterStoricoAnnulla, { id }, authHeaders());
    return parseNewsletterHistoryDetail(response.data);
  } catch (error) {
    throw new Error(extractErrorMessage(error, "Errore durante l'annullamento della newsletter programmata"));
  }
};
